<template>
	<svg
		class="icon"
		aria-hidden="true"
		:style="`--icon-size: var(--icon-size-${size})`"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
	>
		<slot />
	</svg>
</template>

<script setup lang="ts">
const { size = 'md' } = defineProps<{
	size?: 'sm' | 'md' | 'lg'
}>()
</script>

<style scoped>
.icon {
	aspect-ratio: 1;
	fill: currentcolor;
	flex-shrink: 0;
	inline-size: var(--icon-size);
}
</style>
